import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import React from 'react'
import Styles from './WithAutopilotUpgradeBadge.module.scss'
import { Tooltip } from 'components/Tooltip/Tooltip'
import Lock2 from 'blaze-ui/icons/24/Lock2'

type ChildProps = { isRenderingBadge: boolean }
type WithAutopilotUpgradeBadgeProps = {
  children?: React.ReactNode | ((args: ChildProps) => React.ReactNode)
  color?: string
}

export const WithAutopilotUpgradeBadge = ({ children, color }: WithAutopilotUpgradeBadgeProps): React.ReactElement => {
  const workspace = useCurrentWorkspace()
  const isBadgeVisible = Boolean(workspace?.is_ap_freemium)

  const content =
    typeof children === 'function'
      ? (children as (args: ChildProps) => React.ReactNode)({ isRenderingBadge: isBadgeVisible })
      : children

  if (isBadgeVisible) {
    return (
      <div className={Styles.container}>
        {content}

        <Tooltip label="Upgrade to unlock this feature">
          <div className={Styles.center}>
            <Lock2 size={16} color={color || '#9500FF'} />
          </div>
        </Tooltip>
      </div>
    )
  }

  return <>{content}</>
}
